import { Entity, formatTicker, ThemeExposure, ThemeSchemaResponse } from '@api';
import { NonLinearStepper } from '@terminal/components/non-linear-stepper/NonLinearStepper';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './StepperSection.module.scss';

interface StepperSectionProps {
  entity?: Entity;
  theme: ThemeExposure | { theme: ThemeSchemaResponse };
  title?: string;
  description?: string;
  activeIndex: number;
  rightHeaderNode?: ReactNode;
}

const getParent = (
  theme: ThemeExposure['theme'] | ThemeSchemaResponse
): { id: string; name: string; logo_url?: string } =>
  'parent' in theme ? theme.parent : theme.parent_theme;

export const StepperSection = ({
  entity,
  theme,
  title,
  activeIndex,
  description,
  rightHeaderNode,
}: StepperSectionProps) => {
  const { t } = useTranslation(['widget']);
  return (
    <div className={styles.sectionRow} data-testid="stepper-section">
      <div className={styles.headerWrapper}>
        {title && <div className={styles.titleMedium}>{title}</div>}
        {rightHeaderNode}
      </div>
      {entity && (
        <div className={styles.stepperWrapper}>
          <NonLinearStepper
            steps={[
              {
                logoUrl: entity.logo_urls.light_png,
                hoverLabel: formatTicker(entity),
                connectorLabel: t(
                  'widget:assetOverview.knowledgeGraph.exposedTo'
                ),
              },
              {
                logoUrl: theme.theme.logo_url,
                hoverLabel: theme.theme.name,
                connectorLabel: t(
                  'widget:assetOverview.knowledgeGraph.memberOf'
                ),
                iconColor: 'var(--kg-theme)',
              },
              {
                logoUrl: getParent(theme.theme).logo_url,
                hoverLabel: getParent(theme.theme).name,
                iconColor: 'var(--kg-parent)',
              },
            ]}
            activeIndex={activeIndex}
            iconSize={23}
          />
        </div>
      )}
      {description && <div className={styles.bodySmall}>{description}</div>}
    </div>
  );
};
